import { Component, OnInit } from '@angular/core';
import { SystemUser } from '../system-user';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { STUDENTLANGUAGES } from '../student-languages-list';
import { Booking } from '../booking';
import { UserService } from '../service/user.service';
import { HttpService } from '../service/http.service';
import { FaviconService } from '../favicon.service';
import { MessageService } from 'primeng/api';
import * as moment from 'moment';
import { School } from '../school';
import { Country } from '../country';
import { Language } from '../language';
import { EtcBooking } from '../etc-booking';

@Component({
  selector: 'app-create-etc-booking',
  templateUrl: './create-etc-booking.component.html',
  styleUrls: ['./create-etc-booking.component.css']
})
export class CreateEtcBookingComponent implements OnInit {

  user!: SystemUser;
  bookingForm!: FormGroup;
  hasError!: boolean;
  hasDateError!: boolean;
  success!: boolean;
  languages: Language[] = STUDENTLANGUAGES;
  createdBooking!: EtcBooking | null;
  formPath!: string;
  bookingsToCompare!: Booking[];
  etcSchool!: School;

  defaultEndDate!: Date;
  sendingRequest = false;

  constructor(
    public userService: UserService,
    private httpService: HttpService,
    private formBuilder: FormBuilder,
    private favicon: FaviconService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.favicon.sbms();
    this.user = new SystemUser(this.userService.userName, this.userService.roles!);
    this.bookingForm = this.formBuilder.group({
      lastName: ["", Validators.required],
      firstName: ["", Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, [Validators.required]],
      studentLanguage: [this.languages[0], [Validators.required]]
    });
    this.httpService.getSchoolById(28).subscribe(res => this.etcSchool = res);
    this.httpService.getAllBookings()
    .subscribe(bookings => this.bookingsToCompare = bookings);
  }

  createBooking() {
    console.log(this.bookingForm);
    if (!this.bookingForm.valid) {
      this.addError("Form invalid", "Please check input value and try again.");
      return;
    }
    this.createdBooking = null;
    this.hasError = false;
    this.success = false;
    if (moment(this.bookingForm.value.startDate).add(5, 'day') > moment(this.bookingForm.value.endDate)) {
      this.addError("Date range invalid", "Students have to stay at least 5 days.");
    } else {
      for(let booking of this.bookingsToCompare){
        if(
          booking.student.firstName.toLowerCase() == this.bookingForm.value.firstName.toLowerCase().trim()
           && booking.student.lastName.toLowerCase() == this.bookingForm.value.lastName.toLowerCase().trim()
        ){
          console.log("duplicated first name and last name");
          this.addWarningDialog("booking with " + this.bookingForm.value.firstName + " " + this.bookingForm.value.lastName + " exist already.", "are you sure to create a booking for this person?");
          return;
        }
      };
      this.submitForm();
    }
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addWarningDialog(summary: string, detail: string){
    this.messageService.add({key: "dialog", sticky: true, severity: 'warn', summary: summary, detail: detail})
  }

  copyUrl(){
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData!.setData("text/plain", this.formPath);
      this.addSuccess("URL copy success !", "You copied url: " + e.clipboardData!.getData("text/plain"));
      e.preventDefault();
    });
    document.removeEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData!.setData("text/plain", this.formPath);
      this.addSuccess("URL copy success !", "You copied url: " + e.clipboardData!.getData("text/plain"));
      e.preventDefault();
    }
    );
    document.execCommand("copy");
  }

  updateEndMonth(){
    let startDateMoment = moment(this.bookingForm.value.startDate);
    let defaultEndDateMoment = startDateMoment.add(5, "days");
    this.defaultEndDate = defaultEndDateMoment.toDate();
  }

  onReject(){
    this.messageService.clear("dialog")
    return;
  }

  onConfirm(){
    this.messageService.clear("dialog");
    this.submitForm();
  }

  submitForm(){
    this.sendingRequest = true;
    let booking = new EtcBooking(
      moment(this.bookingForm.value.startDate, "DD/MM/YYYY").utc(true),
      moment(this.bookingForm.value.endDate, "DD/MM/YYYY").utc(true),
      this.bookingForm.value.studentLanguage,
      this.etcSchool,
      new Country(234, "United Kingdom"),
      this.bookingForm.value.firstName.trim(),
      this.bookingForm.value.lastName.trim(),
    )
    this.httpService.postEtcBooking(booking).subscribe(booking => {
      this.success = true;
      this.sendingRequest = false;
      this.addSuccess("Success", "Your request is sent successfully");
      this.createdBooking = booking;
      // this.formPath = "https://languesvivantes-bruges.com/" + this.createdBooking.language.path + "/etc-parental-permission/" + this.createdBooking.uuid;
      this.bookingForm.reset();
      this.bookingForm.get('studentLanguage')!.setValue(this.languages[0]);
    }, error => {
      this.sendingRequest = false;
      this.addError("HTTP Error", "Form value is valid, but there is an error in sending request to backend.");
      this.hasError = true;
    });
  }

}
